import React from 'react';
import { observer } from "mobx-react-lite";
import { NumberActionDetail } from './components/NumberActionDetail';
import { BooleanActionDetail } from './components/BooleanActionDetail';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { useTranslation } from 'react-i18next';
export const StartTimerActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_time"),
    value: action.time,
    valueSetter: action.setTime.bind(action)
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_visible"),
    checked: action.visible,
    toggle: action.toggleVisible.bind(action)
  }), action.visible && /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_count_down"),
    checked: action.countDown,
    toggle: action.toggleCountDown.bind(action)
  }), action.visible && /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_text_neutral"),
    translatedString: action.text,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: true
  }));
});